/* eslint-disable */
import templateUnauthorize from './templateUnauthorize.phtml';
import templateAuthorize from './templateAuthorize.phtml';
import requestService from "@/js/common/Domain/Service/request";

import './accountBar.scss';

var AccountBarModel = Backbone.Model.extend({
	defaults: {
		userAuthorized: false,
		loadingProfileData: false,
		logoutInProgress: false,
		accountItemShow: 0
	}
});

export default Backbone.Epoxy.View.extend({
	events: {
		'click .openAuthForm': 'openAuthForm',
		'click .accountBar__logInButton': 'openAuthForm',
		'click .accountBar__logout': 'logout',
		'click .accountBar__dropdownButton': 'openLK'
	},
	bindings: {
		':el': 'toggle:accountItemShow',
		'.accountBar__dropdownButton': 'classes:{loading:profileRequestInProgress}',
		'.accountBar__userName': 'text:accountUsername',
	},
	computeds: {
		accountUsername: {
			deps: ["name", "email"],
			get: function (name, email) {
				return name ? name : email;
			}
		}
	},
	openLK: function () {
		window.open(window.appConfig.accountUrl, '_blank');
	},
	logout: function () {
		var self = this,
			options = {
				url: window.appConfig.accountUrl + '/api/customer/logout',
				type: "POST",
				xhrFields: {withCredentials: true}
			};

		if (!this.viewModel.get('logoutInProgress')) {
			this.viewModel.set('logoutInProgress', true);
			requestService(options, {
				success: function (response) {
					self.viewModel.set('logoutInProgress', false);
					if (response.success) {
						self.model.set('authorized', false);
					}
				},
				error: function (response, textStatus) {
					self.viewModel.set('logoutInProgress', false);
				}
			});
		}
	},
	openAuthForm:async function () {
		await this.parent.lazyAuthorizeInit();
		this.parent.authorize.show();
	},
	render: function () {
		var template = this.model.get('authorized') ? templateAuthorize({
			accountDomain: window.appConfig.accountUrl
		}) : templateUnauthorize();
		this.$el.empty().append(template);

		$(document).trigger('accountBarChanged');

		this.applyBindings();
	},
	initModelEvents: function () {
		var self = this;
		this.model.on('change:authorized', $.proxy(this.render, this));

		if (this.model.get('profileDataReceived')) {
			self.viewModel.set('accountItemShow', 1);
		} else {
			this.model.once('profileDataReceived', function () {
				self.viewModel.set('accountItemShow', 1);
			});
		}
	},
	initialize: function (options) {
		this.viewModel = new AccountBarModel();
		this.parent = options.parent;
		this.render();
		this.initModelEvents();
	}
});